import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import api from '../services/api';
import CycleModal from './CycleModal';
import { useSelectStyles } from '../utils/selectStyles';

const ClasseModal = ({ show, onClose, editing, refetch }) => {
  const selectStyles = useSelectStyles();
  const [cycles, setCycles] = useState([]);
  const [showCycleModal, setShowCycleModal] = useState(false);
  const { register, handleSubmit, control, reset, formState: { errors } } = useForm({
    defaultValues: editing || {
      classe: '',
      abrev: '',
      cycle_id: '',
      num_ordre: ''
    }
  });

  useEffect(() => {
    api.get('/cycles').then(res => {
      setCycles(res.data.data || []);
    });
    if (editing) {
      reset(editing);
    } else {
      reset({ classe: '', abrev: '', cycle_id: '', num_ordre: '' });
    }
  }, [editing, reset]);

  const onSubmit = async (data) => {
    try {
      if (editing) {
        await api.put(`/classes/${editing.id}`, data);
      } else {
        await api.post('/classes', data);
      }
      refetch && refetch();
      onClose();
    } catch (e) {
      alert('Erreur lors de l\'enregistrement');
    }
  };

  if (!show) return null;

  const cycleOptions = cycles.map(c => ({ value: c.id, label: c.cycle }));

  // Simule la permission, à remplacer par ta vraie logique d'auth
  const hasCycleCreatePermission = true; // Remplace par ta logique réelle

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 dark:bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4 dark:text-gray-100">{editing ? 'Modifier' : 'Ajouter une'} classe</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nom de la classe *</label>
            <input
              type="text"
              {...register('classe', { required: true })}
              className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            />
            {errors.classe && <span className="text-red-500 dark:text-red-400 text-xs mt-1">Champ obligatoire</span>}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Abréviation *</label>
            <input
              type="text"
              {...register('abrev', { required: true })}
              className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            />
            {errors.abrev && <span className="text-red-500 dark:text-red-400 text-xs mt-1">Champ obligatoire</span>}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              Cycle *
              {hasCycleCreatePermission && (
                <button
                  type="button"
                  className="ml-2 px-2 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                  onClick={() => setShowCycleModal(true)}
                  title="Ajouter un cycle"
                >
                  +
                </button>
              )}
            </label>
            <Controller
              name="cycle_id"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={cycleOptions}
                  value={cycleOptions.find(opt => opt.value === field.value)}
                  onChange={option => field.onChange(option ? option.value : '')}
                  placeholder="Sélectionner..."
                  classNamePrefix="react-select"
                  styles={selectStyles}
                />
              )}
            />
            {errors.cycle_id && <span className="text-red-500 dark:text-red-400 text-xs mt-1">Champ obligatoire</span>}
            {/* Modal d'ajout de cycle */}
            {showCycleModal && (
              <CycleModal
                show={showCycleModal}
                onClose={() => setShowCycleModal(false)}
                onCreated={() => {
                  api.get('/cycles').then(res => setCycles(res.data.data || []));
                }}
              />
            )}
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">N° d'ordre *</label>
            <input
              type="number"
              {...register('num_ordre', { required: true })}
              className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            />
            {errors.num_ordre && <span className="text-red-500 dark:text-red-400 text-xs mt-1">Champ obligatoire</span>}
          </div>
          <div className="flex justify-end space-x-2 mt-6">
            <button type="button" className="px-4 py-2 bg-gray-200 dark:bg-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600" onClick={onClose}>Annuler</button>
            <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700">Enregistrer</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClasseModal;
